import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import es from './lang/es.json';
import en from './lang/en.json';

const resources = {
  es: {
    translation: es,
  },
  en: {
    translation: en
  }
};

export type TSupportedLanguages = keyof typeof resources;

export const SupportedLanguages = Object.keys(
  resources,
) as (keyof typeof resources)[]; // I turn object keys to an array


i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'es',
    lng: 'es',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
